__turbopack_context__.v({
  "dot": "service-status-module-scss-module__nm7zVG__dot",
  "root": "service-status-module-scss-module__nm7zVG__root",
  "word": "service-status-module-scss-module__nm7zVG__word",
});
